type ChainFn = {
    <Input>(value:Input): Input,
    <Input, Fn1Output>(
        value:Input,
        fn1:(v:Input) => Fn1Output,
    ): Fn1Output,
    <Input, Fn1Output, Fn2Output>(
        value:Input,
        fn1:(v:Input) => Fn1Output,
        fn2:(v:Fn1Output) => Fn2Output,
    ): Fn2Output,
    <Input, Fn1Output, Fn2Output, Fn3Output>(
        value:Input,
        fn1:(v:Input) => Fn1Output,
        fn2:(v:Fn1Output) => Fn2Output,
        fn3:(v:Fn2Output) => Fn3Output,
    ): Fn3Output,
    <Input, Fn1Output, Fn2Output, Fn3Output, Fn4Output>(
        value:Input,
        fn1:(v:Input) => Fn1Output,
        fn2:(v:Fn1Output) => Fn2Output,
        fn3:(v:Fn2Output) => Fn3Output,
        fn4:(v:Fn3Output) => Fn4Output,
    ): Fn4Output,
    <Input, Fn1Output, Fn2Output, Fn3Output, Fn4Output, Fn5Output>(
        value:Input,
        fn1:(v:Input) => Fn1Output,
        fn2:(v:Fn1Output) => Fn2Output,
        fn3:(v:Fn2Output) => Fn3Output,
        fn4:(v:Fn3Output) => Fn4Output,
        fn5:(v:Fn4Output) => Fn5Output,
    ): Fn5Output,
    (value: any, ...fList:Array<(v:any) => any>): any,
};
type PipeFn = {
    <Fn1 extends (v:any) => any>(f1: Fn1): Fn1,
    <Input, Fn1Output, Fn2Output>(
        f1: (v: Input) => Fn1Output,
        f2: (v: Fn1Output) => Fn2Output,
    ): (arg:Input) => Fn2Output,
    <Input, Fn1Output, Fn2Output, Fn3Output>(
        f1: (v: Input) => Fn1Output,
        f2: (v: Fn1Output) => Fn2Output,
        f3: (v: Fn2Output) => Fn3Output,
    ): (arg:Input) => Fn3Output,
    <Input, Fn1Output, Fn2Output, Fn3Output, Fn4Output>(
        f1: (v: Input) => Fn1Output,
        f2: (v: Fn1Output) => Fn2Output,
        f3: (v: Fn2Output) => Fn3Output,
        f4: (v: Fn3Output) => Fn4Output,
    ): (arg:Input) => Fn4Output,
    <Input, Fn1Output, Fn2Output, Fn3Output, Fn4Output, Fn5Output>(
        f1: (v: Input) => Fn1Output,
        f2: (v: Fn1Output) => Fn2Output,
        f3: (v: Fn2Output) => Fn3Output,
        f4: (v: Fn3Output) => Fn4Output,
        f5: (v: Fn4Output) => Fn5Output,
    ): (arg:Input) => Fn5Output,
    <Input, Output>(...fns: [(v: Input) => any, ...Array<(v: any) => any>, (v: any) => Output]): (arg: Input) => Output,
};

export const chain:ChainFn = (value: any, ...fList: ((v: any) => any)[]) => {
    for (const fn of fList) {
        value = fn(value);
    }
    return value;
};

export const pipe:PipeFn = (...fns: ((v: any) => any)[]) => (
    (initV: any) => fns.reduce((prevVal, fn) => fn(prevVal), initV)
);

export const chain2 = (value: any, fList: ((v: any) => any)[]) => {
    for (const fn of fList) {
        value = fn(value);
    }
    return value;
};

export const and = <F extends (...args: any[]) => boolean>(...fList: F[]) => {
    return (...args: Parameters<F>) => {
        for (const fn of fList) {
            if (!fn(...args)) {
                return false;
            }
        }
        return true;
    };
};

export const getter = <T extends Record<any, any>, Key extends keyof T>(key: Key) => (
    (v:T) => v[key]
);

export const equals = <T>(a:T) => (b:T) => a === b;

export const not = <F extends (...args:any[]) => any>(f:F) => (...args:Parameters<F>): boolean => !f(...args);

